<template>
  <el-container style="position: fixed; width: 100%; top: 0px; z-index: 999;">
    <el-header class="my-el-header" style="height:80px">
      <img src="../../assets/logo.png" style="margin-left: 80px; margin-top: 10px;height:80%" />
      <el-menu class="my-el-menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
        active-text-color="#ed6c12" text-color="#343434" :router="true">
        <el-menu-item index="1" route="/">首页 </el-menu-item>
        <el-menu-item index="2" route="course">课程体系</el-menu-item>
        <el-menu-item index="3" route="works">下载软件</el-menu-item>
        <el-menu-item index="4" route="school">校区/合作</el-menu-item>
        <el-menu-item index="5" route="about">关于哆哆创客</el-menu-item>
        <!-- <el-menu-item>开始制作</el-menu-item> -->
        <!-- <el-menu-item index="4" route="user">登录学生端</el-menu-item> -->
        <el-menu-item class="link">
          <a class="study-btn" href="http://study.ddcoder.com/" target="_blank" style="color: #ffffff;">登录学习系统</a>
        </el-menu-item>
        <!-- <el-submenu index="5">
          <template slot="title">北飘草</template>
          <el-menu-item index="7">退出登录</el-menu-item>
        </el-submenu> -->

      </el-menu>
    </el-header>
    <!-- <div style="margin-right: 10px; position:absolute; right:10px; top:10px ;">
      <el-button icon="el-icon-user-solid"  type="danger" round>联系老师</el-button>
    </div> -->
  </el-container>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    activeIndex: String
  },
  created () {},
  mounted () {
    window.addEventListener('load', () => {
      if (this.$route.path !== '') {
        // window.location.href = 'https://ddcoder.com/'
      }
    })
  },
  methods: {
    handleSelect (key, keyPath) {}
  }
}

</script>

<style>
  * {
    margin: 0px;
    padding: 0px;

  }

  .my-el-header {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
      0 0 4px 0 rgba(0, 0, 0, 0.2);
  }

  .study-btn {
    background-color: #ff6d01;
    background-image: -moz-linear-gradient(75deg, #ff7e00 0%, #ff3f00 53%, #ff0000 100%);
    background-image: -webkit-linear-gradient(75deg, #ff7e00 0%, #ff3f00 53%, #ff0000 100%);
    background-image: -ms-linear-gradient(75deg, #ff7e00 0%, #ff3f00 53%, #ff0000 100%);
    background-image: linear-gradient(75deg, #ff7e00 0%, #ff3f00 53%, #ff0000 100%);
    transition: all 0.4s ease-out;
    display: inline-block;
    text-align: center;
    letter-spacing: 0;
    vertical-align: top;
    margin-top: 5px;
    padding: 10px;
    text-decoration: none;
    border-radius: 30px;
    line-height: 30px;
    height: 30px;
    width: 120px;

  }

  .my-el-menu {
    margin-top: 10px;
    margin-right: 60px;
    margin-left: 120px;
    min-width: 820px;
  }

  .el-submenu {
    font-size: 18px;

  }

  .my-el-menu .el-menu-item {
    font-size: 18px;
    margin-left: 10px;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .link a {
    vertical-align: top;
  }

</style>



// WEBPACK FOOTER //
// src/components/top/TopNav.vue